import { useContext } from "react";
import { ensure, useNotifications } from "sprint-common-web";

import { CloneEncodeSpecificationFormInputs } from "./CloneEncodeSpecificationForm";
import { useEncodeSpecificationApi } from "../../../../../common/api/orders-api/encode-specification/useEncodeSpecificationApi";
import { EncodeSpecificationContext } from "../../../context/EncodeSpecificationContext";
import { EncodeSpecificationType } from "../../../context/EncodeSpecificationItem";

export const useCloneEncodeSpecificationForm = () => {
    const { cloneEncodeSpecification: cloneEncodeSpec } = useEncodeSpecificationApi();
    const { addEncodeSpecificationMpeg1, addEncodeSpecificationMpeg4, encodeSpecifications } = useContext(
        EncodeSpecificationContext
    );
    const { success, error } = useNotifications();

    const cloneEncodeSpecification = async (id: string, inputs: CloneEncodeSpecificationFormInputs) => {
        const itemToClone = encodeSpecifications.find((item) => item.id === id);
        ensure(itemToClone);

        cloneEncodeSpec({
            id: itemToClone.id,
            name: inputs.name
        })
            .then((response) => {
                if (itemToClone.type === EncodeSpecificationType.MPEG_1) {
                    addEncodeSpecificationMpeg1({ ...itemToClone, id: response.entityId, name: inputs.name });
                } else {
                    addEncodeSpecificationMpeg4({ ...itemToClone, id: response.entityId, name: inputs.name });
                }

                success("Cloned encode specification");
            })
            .catch(() => {
                error("Cannot clone encode specification");
            });
    };

    return {
        cloneEncodeSpecification
    };
};
